export default __webpack_public_path__ + "static/media/p1.93a7adf6.jpg";